module.exports = __webpack_public_path__ + "img/black45.c33f7899.png";